import { useState } from "react";
import type { Property } from "types/qbank/property";
import type { PropertySet } from "types/qbank/propertySet";
import type { PropertyMediaPicker } from "types/qbank/propertyMediaPicker";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PropertyItem from "./PropertyItem";

export default function Properties(props: { propertySet: PropertySet }) {
  const [open, setOpen] = useState<boolean>(false);

  function getpropertyValue(values: string[]) {
    let array: any[] = [];

    values.forEach((item: object | string) => {
      if (typeof item === "string") {
        item = JSON.parse(item);
      }

      let property = item as Property;
      if (property.value) {
        if (typeof property.value === "object") {
          if (
            property.propertyType.definition.hierarchical &&
            Array.isArray(property.value)
          ) {
            array.push(getpropertyValue(property.value));
          } else {
            console.log(
              `Unable to parse property value for ${property.propertyType.name}`,
              property.value
            );
          }
        } else if (property.propertyType.definition.mediapicker) {
          let mediaPickerValue = JSON.parse(
            // @ts-ignore
            property.value
          ) as PropertyMediaPicker;
          if (!mediaPickerValue.deleted) {
            array.push(
              `${mediaPickerValue.title} #${mediaPickerValue.mediaid}`
            );
          }
        } else {
          array.push(property.value);
        }
      }
    });
    return array.flat();
  }

  function renderProperty(property: Property) {
    switch (typeof property.value) {
      case "string":
        return <PropertyItem value={property.value} type="string" />;

      case "boolean":
        return <PropertyItem value={property.value} type="bool" />;

      case "object":
        if (Array.isArray(property.value) && property.value.length > 0) {
          const propertyValues = getpropertyValue(property.value);
          return (
            <PropertyItem
              value={propertyValues}
              type={
                property.propertyType.definition.hierarchical
                  ? "hierarchy"
                  : "array"
              }
            />
          );
        }
        return <PropertyItem value={undefined} type="string" />;

      case "number":
        return <PropertyItem value={property.value.toString()} type="string" />;

      default:
        console.log(
          `Unhandled property type. ${typeof property.propertyType
            .name}; ${typeof property.value}`
        );
        return <PropertyItem value={undefined} type="string" />;
    }
  }

  return (
    <>
      {props.propertySet.properties.length > 0 && (
        <>
          <ListItemButton onClick={() => setOpen(!open)}>
            <ListItemText
              primary={props.propertySet.name}
              primaryTypographyProps={{ variant: "body1" }}
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div">
              {props.propertySet.properties.map((property, index) => (
                <ListItem divider disablePadding key={index}>
                  <ListItemText
                    inset
                    primary={property.propertyType.name}
                    secondary={renderProperty(property)}
                    secondaryTypographyProps={{ component: "span" }}
                  />
                </ListItem>
              ))}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
}
